import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'

import { actionSet } from './utils'
import { callKardexWithPagination } from 'component/pagination/utils'

import {
  FETCH_KARDEX_REQUEST,
  FETCH_KARDEX_SUCCESS,
  FETCH_KARDEX_ERROR,
} from 'actionTypes'

const HAS_PAGINATION = false

export const fetchKardex =
  (token, params, getData, fetchError) => (dispatch) => {
    dispatch(actionSet(FETCH_KARDEX_REQUEST))

    return new Api(token, dispatch)
      .post(API_URL.KARDEX_FIND, {
        ...params,
        hasPagination: HAS_PAGINATION,
      })
      .then(({ data }) => {
        getData(
          dispatch(
            callKardexWithPagination(
              data,
              dispatch,
              FETCH_KARDEX_SUCCESS,
              0,
              params.page
            )
          )
        )
      })
      .catch((error) => {
        dispatch(actionSet(FETCH_KARDEX_ERROR, error))
        fetchError()
      })
  }
